import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type TravauxRegie from '../../interfaces/pieces/mouvements/travauxRegie';

export const getTravauxRegie = async () =>
	request.get<unknown, TemplateRequestGet<TravauxRegie>>(
		'/api/finances/comptabilite/piecescomptables/travauxRegie?all',
	);

export const createTravauxRegie = (travauxRegie: Partial<TravauxRegie>) =>
	request.post<Partial<TravauxRegie>, TravauxRegie>(
		'/api/finances/comptabilite/piecescomptables/travauxRegie',
		travauxRegie,
	);
